import * as React from 'react';

import { FormHeader } from '../FormHeader';
import { IMainScreenProps } from '../..';

import * as styles from './styles.css';

export function MainScreenMobile(props: IMainScreenProps) {
  const { backToPage, progressBar, main, showGoBackBtn, handleGoBack, goBackText } = props;

  return (
    <div className={styles['container']}>
      <div>
        <FormHeader
          backToPage={backToPage}
          progressBar={progressBar}
          showGoBackBtn={showGoBackBtn}
          handleGoBack={handleGoBack}
          goBackText={goBackText}
        />
      </div>
      <div className={styles['content']}>{main}</div>
    </div>
  );
}
